export default __webpack_public_path__ + "assets/47d1c141b23be459d37abff967c1d4da.png";